import identity from "./identity.js";
import isFunction from "./isFunction.js";
import isObject from "./isObject.js";
import isArray from "./isArray.js";
import matcher from "./matcher.js";
import property from "./property.js";
import optimizeCb from "./_optimizeCb.js";
export default function baseIteratee(value, context, argCount) {
  if (value == null) return identity;
  if (isFunction(value)) return optimizeCb(value, context, argCount);
  if (isObject(value) && !isArray(value)) return matcher(value);
  return property(value);
}
